import { FC, useContext } from 'react'
import { Box } from '@mui/material'

import { LoginForm } from '../../_ui/LoginForm'

import { AuthContext } from '../../providers'

import SiteInfo from './SiteInfo'
import { dbg } from '../../_utilities'

export const LoginContainer: FC = () => {
  const { auth, signIn } = useContext(AuthContext)
  //dbg.log('-----Mounting LoginContainer------------')

  const handleSubmit = async (username: string, password: string) => {
    try {
      await signIn(username, password)
      return true
    } catch (err) {
      return false
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: ['column', 'row'],
        justifyContent: 'space-between',
        width: ['100%', 'calc(100% - 24px)'],
      }}
    >
      <Box
        sx={{
          width: ['100%', `${(100 * 2) / 3}%`],
        }}
      >
        <SiteInfo />
      </Box>

      <Box
        sx={{
          marginLeft: [0, '24px'],
          width: ['100%', `${100 / 3}%`],
          marginTop: ['16px', 0]
        }}
      >
        <LoginForm
          handleLogin={handleSubmit}
          errors={{
            accessDenied: auth?.accessDenied
          }}
        />
      </Box>
    </Box>
  )
}

export default LoginContainer
